import * as React from "react";
import {
  Dialog,
  Stack,
  Slide,
  AppBar,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import type { TransitionProps } from "@mui/material/transitions";
import { IconX } from "@tabler/icons-react";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type DrawerDetailStudentsProps = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

const DrawerDetailStudents = ({
  open,
  onClose,
  children,
}: DrawerDetailStudentsProps) => {
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      sx={{
        zIndex: 1200,
        "& .MuiDialog-paper": {
          bgcolor: "#2e2e2e",
          color: "#fff",
          backgroundImage: "none",
          boxShadow: "none",
          display: "flex",
          flexDirection: "column",
        },
      }}
      TransitionComponent={Transition}
      keepMounted
      TransitionProps={{
        timeout: { enter: 300, exit: 200 },
      }}
    >
      <AppBar
        sx={(theme) => ({
          backgroundColor: "primary.dark",
          boxShadow: 0,
          height: 42,
          [theme.breakpoints.down("sm")]: {
            marginTop: 7,
          },
        })}
      >
        <Toolbar sx={{ minHeight: 42, height: 42, alignItems: "center" }}>
          <Stack sx={{ flex: 1, justifyContent: "center" }}>
            <Typography variant="h6" component="div">
              Detalhes do aluno
            </Typography>
          </Stack>

          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <IconX />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Toolbar />
      <Stack spacing={1} py={3} sx={{ p: "1rem", backgroundColor: "#2e2e2e" }}>
        {children}
      </Stack>
    </Dialog>
  );
};

export default DrawerDetailStudents;
